{
  "metadata": {
    "id": "github-dark",
    "name": "GitHub",
    "description": "Портировано из темы «GitHub» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "github.json",
      "project": "primer",
      "url": "https://github.com/primer/github-vscode-theme",
      "upstreamFile": "packages/ui/src/theme/themes/github.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.6,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.476,
      "paletteMaxS": 0.516,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.2,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 35.3,
      "syntaxVsTextMinDeltaE": 22.6,
      "chartsMinDeltaE": 39.2,
      "textSeparationDeltaE": 21.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "string",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#58a6ff",
      "hover": "#6cb1ff",
      "active": "#79b8ff",
      "foreground": "#000000",
      "muted": "#58a6ff80",
      "emphasis": "#58a6ff"
    },
    "surface": {
      "background": "#0d1117",
      "foreground": "#c9d1d9",
      "muted": "#22272d",
      "mutedForeground": "#8f97a1",
      "elevated": "#2b3036",
      "elevatedForeground": "#c9d1d9",
      "raised": "#444a51",
      "raisedForeground": "#c9d1d9",
      "overlay": "#0d1117cc",
      "subtle": "#191e24"
    },
    "interactive": {
      "border": "#474c53",
      "borderHover": "#42474d",
      "borderFocus": "#58a6ff",
      "selection": "#c9d1d929",
      "selectionForeground": "#c9d1d9",
      "focus": "#58a6ff59",
      "focusRing": "#58a6ff61",
      "cursor": "#c9d1d9",
      "hover": "#c9d1d91c",
      "active": "#c9d1d929"
    },
    "status": {
      "error": "#f85149",
      "errorForeground": "#000000",
      "errorBackground": "#f8514924",
      "errorBorder": "#f8514973",
      "warning": "#e3b341",
      "warningForeground": "#000000",
      "warningBackground": "#e3b34124",
      "warningBorder": "#e3b34173",
      "success": "#3fb950",
      "successForeground": "#000000",
      "successBackground": "#3fb95024",
      "successBorder": "#3fb95073",
      "info": "#d29922",
      "infoForeground": "#000000",
      "infoBackground": "#d2992224",
      "infoBorder": "#d2992273"
    },
    "pr": {
      "open": "#3fb950",
      "draft": "#939ca5",
      "blocked": "#e3b341",
      "merged": "#39c5cf",
      "closed": "#f85149"
    },
    "syntax": {
      "base": {
        "background": "#2f343b",
        "foreground": "#c9d1d9",
        "comment": "#939ca5",
        "keyword": "#ff7b72",
        "string": "#39c5cf",
        "number": "#58a6ff",
        "function": "#39c5cf",
        "variable": "#d29922",
        "type": "#d29922",
        "operator": "#ff7b72"
      },
      "tokens": {
        "commentDoc": "#939ca5",
        "stringEscape": "#ff7b72",
        "keywordImport": "#ff7b72",
        "storageModifier": "#ff7b72",
        "functionCall": "#39c5cf",
        "method": "#39c5cf",
        "variableProperty": "#39c5cf",
        "variableOther": "#d29922",
        "variableGlobal": "#58a6ff",
        "variableLocal": "#ff7b72",
        "parameter": "#d29922",
        "constant": "#58a6ff",
        "class": "#d29922",
        "className": "#d29922",
        "interface": "#d29922",
        "struct": "#d29922",
        "enum": "#d29922",
        "typeParameter": "#d29922",
        "namespace": "#d29922",
        "module": "#ff7b72",
        "tag": "#ff7b72",
        "jsxTag": "#ff7b72",
        "tagAttribute": "#39c5cf",
        "tagAttributeValue": "#39c5cf",
        "boolean": "#58a6ff",
        "decorator": "#ff7b72",
        "label": "#39c5cf",
        "regexp": "#39c5cf"
      }
    },
    "charts": {
      "series": [
        "#58a6ff",
        "#d29922",
        "#3fb950",
        "#dde341",
        "#f85149"
      ]
    },
    "chat": {
      "background": "#0d1117",
      "userMessage": "#c9d1d9",
      "userMessageBackground": "#2b3036",
      "assistantMessage": "#c9d1d9",
      "assistantMessageBackground": "#22272d",
      "timestamp": "#939ca5",
      "divider": "#474c53",
      "typing": "#939ca5"
    },
    "loading": {
      "spinner": "#58a6ff",
      "spinnerTrack": "#22272d",
      "skeleton": "#22272d",
      "shimmer": "#383d44"
    },
    "tools": {
      "background": "#22272d",
      "border": "#474c53",
      "headerHover": "#373c43",
      "icon": "#58a6ff",
      "title": "#c9d1d9",
      "description": "#939ca5",
      "edit": {
        "added": "#3fb950",
        "addedBackground": "#3fb95024",
        "removed": "#f85149",
        "removedBackground": "#f8514924",
        "modified": "#d29922",
        "modifiedBackground": "#d2992224",
        "lineNumber": "#939ca5"
      }
    },
    "markdown": {
      "heading1": "#c9d1d9",
      "heading2": "#c9d1d9",
      "heading3": "#c9d1d9",
      "heading4": "#c9d1d9",
      "link": "#58a6ff",
      "linkHover": "#6cb1ff",
      "inlineCode": "#39c5cf",
      "inlineCodeBackground": "#22272d",
      "blockquote": "#939ca5",
      "blockquoteBorder": "#474c53",
      "listMarker": "#58a6ffbf",
      "bold": "#c9d1d9",
      "italic": "#c9d1d9e6",
      "strikethrough": "#939ca5",
      "hr": "#474c53"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c05343",
        "foreground": "#ffffff",
        "contrast": 4.61
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#ddb49a",
        "foreground": "#000000",
        "contrast": 11.07
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c49b4e",
        "foreground": "#000000",
        "contrast": 8.15
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#b2c856",
        "foreground": "#000000",
        "contrast": 11.29
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#bfe09e",
        "foreground": "#000000",
        "contrast": 14.37
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#54c651",
        "foreground": "#000000",
        "contrast": 9.57
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#59bb7e",
        "foreground": "#000000",
        "contrast": 8.83
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#acdecd",
        "foreground": "#000000",
        "contrast": 14.08
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#52b4c4",
        "foreground": "#000000",
        "contrast": 8.68
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4e84b6",
        "foreground": "#000000",
        "contrast": 5.3
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3f66bc",
        "foreground": "#ffffff",
        "contrast": 5.47
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#ada0dd",
        "foreground": "#000000",
        "contrast": 8.85
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#6442ba",
        "foreground": "#ffffff",
        "contrast": 6.93
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#b849bf",
        "foreground": "#000000",
        "contrast": 4.74
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c04891",
        "foreground": "#ffffff",
        "contrast": 4.59
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c57188",
        "foreground": "#000000",
        "contrast": 6.09
      }
    ]
  }
}
